import './ReferralQuestion.scss'

import React, {Component} from 'react'
import {
  TITLE_PLACED_ORDER_CHOICES, ANSWER_TYPE, QUESTION_TYPE,
} from 'common/constants'
import cx from 'classnames'
import {connect} from 'react-redux'
import {createStructuredSelector} from "reselect"

import {
  selectTitlePlacedOrderQuestion,
} from "manager/selectors/referral_selectors"
import {updateAgentTitleQuestions} from "manager/redux/referral"

class ReferralQuestionTitlePlacedOrder extends Component {

  handleOnClick = (value) => {
    const {updateAgentTitleQuestions} = this.props
    updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_PLACED_ORDER]: {[ANSWER_TYPE.YES_NO]: value}})
  }

  render() {
    const {titlePlacedOrderAnswer} = this.props

    return (
      <div className="ReferralQuestion">
        <div className="question">Have you already placed a title order for this transaction?</div>
        <div className="choice-btns">
          {TITLE_PLACED_ORDER_CHOICES.map(({label, value}) => (
            <button
              key={value}
              onClick={() => this.handleOnClick(value)}
              className={cx('StatusChoice', {
                'StatusChoice__selected': titlePlacedOrderAnswer && titlePlacedOrderAnswer[ANSWER_TYPE.YES_NO] === value
              })}>
              {label}
            </button>
          ))}
        </div>
      </div>
    )
  }

}

const selector = createStructuredSelector({
  titlePlacedOrderAnswer: selectTitlePlacedOrderQuestion,
})

const actions = {
  updateAgentTitleQuestions
}

export default connect(selector, actions)(ReferralQuestionTitlePlacedOrder)
